import { useMemo } from 'react';
import { useEvictedAccessRequests } from '../contexts/EvictedAccessRequestsContext';
import type { AccessRequestNodeFragment } from '../gql/fragments/generated/AccessRequestNode';

/** Returns only access requests that have not been marked for decline */
export function useFilteredAccessRequests({
  accessRequestNodes,
  total,
}: {
  accessRequestNodes: AccessRequestNodeFragment[];
  total: number;
}) {
  const { evictedAccessRequests } = useEvictedAccessRequests();
  const filteredNodes = useMemo(() => {
    return accessRequestNodes.filter(
      (accessRequest) =>
        !evictedAccessRequests.some(
          (evicted) => evicted.accessRequest.id === accessRequest.id
        )
    );
  }, [accessRequestNodes, evictedAccessRequests]);

  const filteredCount = total - evictedAccessRequests.length;

  return {
    filteredAccessRequests: filteredNodes,
    filteredCount,
  };
}
